import Accounts from "views/superAdmin-all/Accounts";
import AptitudeGames from "views/superAdmin-all/AptitudeGames";
import CognitiveGames from "views/superAdmin-all/CognitiveGames";
import Competencies from "views/superAdmin-all/Competencies";
import Settings from "views/superAdmin/Settings";
import ProgressGames from "views/superAdmin-all/ProgressGames";

import Payments from "../views/superAdmin/Payments";
import Questionnaire from "../views/superAdmin/Questionnaire";
import CandidateFlowConfig from "views/superAdmin-all/CandidateFlowConfig";

const routes = [
    {
        path: "/accounts",
        name: "Accounts",
        icon: "",
        component: Accounts,
        layout: "/admin",
        display: true,
        environment: "common",
    },

    {
        path: "/competencies",
        name: "Competencies",
        icon: "",
        component: Competencies,
        layout: "/admin",
        display: true,
        environment: "common",
    },
    {
        path: "/aptitudegames",
        name: "Aptitude Games",
        icon: "",
        component: AptitudeGames,
        layout: "/admin",
        display: true,
        environment: "ace",
    },
    {
        path: "/cognitive",
        name: "Cognitive Games",
        icon: "",
        component: CognitiveGames,
        layout: "/admin",
        display: true,
        environment: "ace",
    },
    {
        path: "/candidate_config",
        name: "Candidate Configurations",
        icon: "",
        component: CandidateFlowConfig,
        layout: "/admin",
        display: true,
        environment: "common",
    },
    {
        path: "/games",
        name: "Games",
        component: ProgressGames,
        layout: "/admin",
        display: true,
        environment: "progress",
    },
    {
        path: "/questionnaire",
        name: "Questionnaire",
        icon: "",
        component: Questionnaire,
        layout: "/admin",
        display: true,
        environment: "common",
    },
    {
        path: "/payments",
        name: "Payments",
        icon: "",
        component: Payments,
        layout: "/admin",
        display: true,
        environment: "common",
    },

    {
        path: "/settings",
        name: "Settings",
        // icon: settings,
        // icon2: leaderboard2,
        component: Settings,
        layout: "/admin",
        display: true,
        environment: "common",
        // display2: false,
    },
];
export default routes;
